import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-loader',
  templateUrl: './page-loader.component.html',
  styleUrls: ['./page-loader.component.scss']
})
export class PageLoaderComponent implements OnInit {

  constructor() { }

  @Input() pageLoaderVm: IPageLoaderViewModel;

  ngOnInit(): void {
  }

}

/**
 * 
 */
export interface IPageLoaderViewModel {
  workingText?: string;
  errorText?: string;
}